import React, { useState, useContext, useRef, useEffect } from 'react'
import { CssEditorContext } from '../contexts/CssEditorContext'
import { setCss, updateGameUpdates } from '../services/userServices'
import { UserContext } from '../contexts/UserContext'
import config from '../config'

export default function CssEditor() {
  const [showModal, setShowModal] = useState(false)
  const [showSvgModal, setShowSvgModal] = useState(false)
  const { cssVariables, updateCssVariable, resetCssVariables } = useContext(CssEditorContext)

  const modalRef = useRef(null);
  const svgModalRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const [svgPosition, setSvgPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  const dragStartMousePos = useRef({ x: 0, y: 0 });
  const dragStartModalPos = useRef({ x: 0, y: 0 });

  const { id: userId, getScratchConfig } = useContext(UserContext);

  const [dialog, setDialog] = useState({ isOpen: false, message: '' });



  const [rewardTitle, setRewardTitle] = useState('');


  const handleSaveRewardTitle = async () => {
    const response = await updateGameUpdates(getScratchConfig.spinWheelId, rewardTitle, config.apigameid);
    if (response.success) {
      setDialog({
        isOpen: true,
        message: 'Ödül metni başarıyla kaydedildi!'
      });
    }
  }
  // Accordion state
  const [openAccordion, setOpenAccordion] = useState('genel');
  const toggleAccordion = (key) => {
    setOpenAccordion(openAccordion === key ? null : key);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    setPosition({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  }


  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleCloseSvgModal = () => {
    setShowSvgModal(false)
  }

  const handleSaveCss = async () => {
    // API'ye gönderilecek JSON formatı
    try {
      const response = await setCss(cssVariables); // setCss API'sini çağırın

      if (response.success) {
        setDialog({
          isOpen: true,
          message: 'CSS ayarları başarıyla kaydedildi!'
        });
      }
    } catch (error) {
      console.error('Error saving CSS settings:', error);
      setDialog({
        isOpen: true,
        message: 'CSS ayarları kaydedilirken bir hata oluştu.'
      });
    }
  }

  const handleVariableChange = (variableName, value) => {
    updateCssVariable(variableName, value);
    // Eğer dialog buton kenarlık rengi değişiyorsa, üst çizgi rengini de güncelle
    if (variableName === '--dialog-action-button-border') {
      updateCssVariable('--dialog-top-line-color', value);
    }
  }

  const handleGradientChange = (variableName, color1, color2, direction = '135deg') => {
    const gradientValue = `linear-gradient(${direction}, ${color1}, ${color2})`
    updateCssVariable(variableName, gradientValue)
  }

  // Gradient değerlerini renklerine ayırma fonksiyonu
  const parseGradient = (gradientValue) => {
    if (!gradientValue) return { color1: '#000000', color2: '#000000', direction: '135deg' }

    const match = gradientValue.match(/linear-gradient\((\d+)deg,\s*([^,]+),\s*([^)]+)\)/)
    if (match) {
      return {
        direction: `${match[1]}deg`,
        color1: match[2].trim(),
        color2: match[3].trim()
      }
    }
    // Handle rgba colors within gradient for profile/shake-rights if needed, assuming they are the only colors
    const rgbaMatch = gradientValue.match(/linear-gradient\((\d+)deg,\s*(rgba\([^)]+\)),\s*(rgba\([^)]+\))\)/);
    if (rgbaMatch) {
      return {
        direction: `${rgbaMatch[1]}deg`,
        color1: rgbaMatch[2].trim(),
        color2: rgbaMatch[3].trim(),
      };
    }
    return { color1: '#000000', color2: '#000000', direction: '135deg' }
  }

  const handleMouseDown = (e, isSvgModal = false) => {
    const modal = isSvgModal ? svgModalRef.current : modalRef.current;
    if (!modal) return;

    setIsDragging(true);
    dragStartMousePos.current = { x: e.pageX, y: e.pageY };

    const rect = modal.getBoundingClientRect();
    dragStartModalPos.current = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const deltaX = e.pageX - dragStartMousePos.current.x;
    const deltaY = e.pageY - dragStartMousePos.current.y;

    const newX = dragStartModalPos.current.x + deltaX;
    const newY = dragStartModalPos.current.y + deltaY;

    if (showSvgModal) {
      setSvgPosition({ x: newX, y: newY });
    } else {
      setPosition({ x: newX, y: newY });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleMouseMove, { passive: false });
      document.addEventListener('touchend', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging, showSvgModal]);

  // Genel arka plan gradyanı için state
  const [bgGradientColor1, setBgGradientColor1] = useState(cssVariables['--general-bg-gradient'] ? parseGradient(cssVariables['--general-bg-gradient']).color1 : '#17171A');
  const [bgGradientColor2, setBgGradientColor2] = useState(cssVariables['--general-bg-gradient'] ? parseGradient(cssVariables['--general-bg-gradient']).color2 : '#2B0A50');
  const [bgGradientAngle, setBgGradientAngle] = useState(cssVariables['--general-bg-gradient'] ? parseGradient(cssVariables['--general-bg-gradient']).direction.replace('deg', '') : '135');

  useEffect(() => {
    // Gradyan değiştiğinde CSS değişkenini güncelle
    const gradientValue = `linear-gradient(${bgGradientAngle}deg, ${bgGradientColor1} 0%, ${bgGradientColor2} 100%)`;
    updateCssVariable('--general-bg-gradient', gradientValue);
    // eslint-disable-next-line
  }, [bgGradientColor1, bgGradientColor2, bgGradientAngle]);

  return (
    <div>
      <div className='general-css-editor-left'>
        <button onClick={resetCssVariables}>VARSAYILAN CSS'E DÖN</button>
        <button onClick={handleSaveCss}>CSS'İ KAYDET</button>
      </div>
      <div className='general-css-editor-right'>
        <button onClick={handleOpenModal}>TASARIM EDİTÖRÜ</button>
      </div>

      {showModal && (
        <div className="css-editor-overlay">
          <div
            className="css-editor-modal"
            ref={modalRef}
            style={{
              position: 'absolute',
              top: position.y,
              left: position.x,
              transform: 'translate(-50%, -50%)',
              cursor: isDragging ? 'grabbing' : 'grab',
            }}
            onMouseDown={(e) => handleMouseDown(e, false)}
            onTouchStart={(e) => handleMouseDown(e, false)}
          >
            <div className="css-editor-header">
              <h2>Tasarım Editörü</h2>
              <button onClick={handleCloseModal}>✕</button>
            </div>
            <div className="css-editor-content">
              <div className="css-editor-accordion">
                {/* Genel Ayarlar */}
                <div className="accordion-section">
                  <div className="accordion-title" onClick={() => toggleAccordion('genel')}>
                    <h3>Genel Ayarlar</h3>
                    <span>{openAccordion === 'genel' ? '▲' : '▼'}</span>
                  </div>
                  {openAccordion === 'genel' && (
                    <div className="accordion-body">
                      {/* Modal ve modal butonları için renk ayarları */}
                      <div className="color-picker-row">
                        <label>Modal Arka Plan Rengi</label>
                        <input type="color" value={cssVariables['--modal-bg'] || '#1e1e1e'} onChange={e => handleVariableChange('--modal-bg', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Modal Kenarlık Rengi</label>
                        <input type="color" value={cssVariables['--modal-border'] || '#c12737'} onChange={e => handleVariableChange('--modal-border', e.target.value)} />
                      </div>

                      <div className="color-picker-row">
                        <label>Buton Arka Plan Rengi</label>
                        <input type="color" value={cssVariables['--modal-button-bg'] || '#c12737'} onChange={e => handleVariableChange('--modal-button-bg', e.target.value)} />
                      </div>

                      <div className="color-picker-row">
                        <label>Buton Yazı Rengi</label>
                        <input type="color" value={cssVariables['--modal-button-text'] || '#fff'} onChange={e => handleVariableChange('--modal-button-text', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Buton Kenarlık Rengi</label>
                        <input type="color" value={cssVariables['--modal-button-border'] || '#c12737'} onChange={e => handleVariableChange('--modal-button-border', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Başlık Rengi</label>
                        <input type="color" value={cssVariables['--modal-title-color'] || '#f9f6e7'} onChange={e => handleVariableChange('--modal-title-color', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Açıklama Rengi</label>
                        <input type="color" value={cssVariables['--modal-desc-color'] || '#f9f6e7'} onChange={e => handleVariableChange('--modal-desc-color', e.target.value)} />
                      </div>

                      <div className="color-picker-row">
                        <label>Input Arka Plan Rengi</label>
                        <input type="color" value={cssVariables['--modal-input-bg'] || '#232323'} onChange={e => handleVariableChange('--modal-input-bg', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Input Yazı Rengi</label>
                        <input type="color" value={cssVariables['--modal-input-text'] || '#fff'} onChange={e => handleVariableChange('--modal-input-text', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Input Kenarlık Rengi</label>
                        <input type="color" value={cssVariables['--modal-input-border'] || '#232323'} onChange={e => handleVariableChange('--modal-input-border', e.target.value)} />
                      </div>
                      <div className="color-picker-row">
                        <label>Genel Arka Plan Gradyanı</label>
                        <input type="color" value={bgGradientColor1} onChange={e => setBgGradientColor1(e.target.value)} />
                        <input type="color" value={bgGradientColor2} onChange={e => setBgGradientColor2(e.target.value)} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
      .color-picker-group {
        display: flex;
        flex-direction: column;
        gap: 22px;
        margin-bottom: 20px;
      }
      .color-picker-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        width: 100%;
      }
      .color-picker-row label {
        color: #f9f6e7;
        font-weight: 500;
        font-size: 15px;
        margin-bottom: 2px;
      }
      .color-picker-row input[type='color'],
      .color-picker-row input[type='number'] {
        width: 100%;
        min-width: 120px;
        max-width: 100%;
        height: 44px;
        border: none;
        background: #232323;
        cursor: pointer;
        border-radius: 6px;
        box-shadow: none;
        padding: 0;
      }
      .color-picker-row input[type='number'] {
        background: #232323;
        color: #f9f6e7;
        padding: 8px 12px;
        font-size: 16px;
        border: 1px solid #444;
        height: 44px;
      }
      .color-picker-row span {
        color: #f9f6e7;
        font-size: 16px;
        font-weight: 500;
        margin-top: 4px;
      }
      .accordion-title h3 {
        font-size: 17px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 0;
        letter-spacing: 0.3px;
      }
      .css-editor-modal {
        background: rgba(30, 30, 40, 0.97) !important;
        border-radius: 16px !important;
        box-shadow: 0 4px 24px 0 rgba(0,0,0,0.18) !important;
        padding: 36px 20px !important;
      }
      .css-editor-header h2 {
        font-size: 22px;
        font-weight: 800;
        color: #fff;
        letter-spacing: 0.5px;
      }
      `}</style>

    </div>
  )
}
